<template>
  <div id="data_desc">
    <el-table :data="deposition" style="width: 70%" v-if="is_show_all_Accession" id="main-tb-deposition">
        <el-table-column prop="Accession" label="Project Accession" >
          <template #default="scope">
             <el-button @click="is_show_all_Accession=false">{{ scope.row.Accession}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="Title" label="Title / Alias" />
        <el-table-column prop="Taxon" label="Taxon Name" />
        <el-table-column prop="Release" label="Release Date" />
        <el-table-column prop="Status" label="Status" />
        <el-table-column prop="Citation" label="Citation/PMID" />
    </el-table>
    <component v-else v-bind:is="currentDetailInfo"></component>
  </div>
  
</template>

<script>
import data_detail from './data-detail.vue'
export default {
  name: "data_desc",
  data() {
    return {
        deposition: [
        {
          Accession: 'GIFTS2021-1',
          Title: 'DrABC: Deep Learning Accurately Predicts Germline Pathogenic Mutation Status in Breast Cancer Patients Based on Phenotype Data',
          Taxon: 'Homo sapiens',
          Release:'18 Dec, 2021',
          Status:'Processed Succeed',
          Citation:'J Liu, et al. DrABC: Deep Learning Accurately Predicts Germline Pathogenic Mutation Status in Breast Cancer Patients Based on Phenotype Data. In submission.'
        }
      ],
      is_show_all_Accession:true
    }
    },
    computed: {
          currentDetailInfo: function() {
            return "data_detail";
          }
    },
    components: {
        data_detail
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
#main-tb-deposition{
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 30em;
}
</style>

